// extracted by mini-css-extract-plugin
module.exports = {"cardPaddingsOverwrite":"LoadingContent__cardPaddingsOverwrite___jk-he"};